import { render, staticRenderFns } from "./GlobalSportsCards.vue?vue&type=template&id=1c11111a&scoped=true"
import script from "./GlobalSportsCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSportsCards.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSportsCards.vue?vue&type=style&index=0&id=1c11111a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c11111a",
  null
  
)

export default component.exports